export const STORE_EVALUATIONS_ADMIN_PAGE = () => "/operacoes/avaliacoes-lojas";
export const STORE_EVALUATION_DETAIL_PAGE = (evaluationId: string) => `/operacoes/avaliacoes-lojas/${evaluationId}`;
export const STORE_QUALITY_DASHBOARD_PAGE = () => "/operacoes/qualidade-lojas";

/** Cobertura semanal dos supervisores de campo; `?semana=AAAA-MM-DD` (a segunda). */
export const STORE_COVERAGE_PAGE = () => "/operacoes/cobertura-semanal";
